import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAllHotelExtras as deleteAllHotelExtrasAPI } from "../../api/apiHotelExtras";
import parseError from "../../utils/parseError";

const useDeleteAllHotelExtras = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteAll, isPending: isDeleteAll } = useMutation({
        mutationFn: deleteAllHotelExtrasAPI,
        onSuccess: (res) => {
            const message = res?.message || "Selected hotel extras deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelExtras"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete selected hotel extras");
        },
    });

    return { deleteAllHotelExtras: deleteAll, isDeleteAll };
};

export default useDeleteAllHotelExtras;
